import { Button, Form, Modal, Spinner } from "react-bootstrap";
import AppLayout from "../layout/AppLayout";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import { useAlert } from "react-alert";
import Loader from "../loader/loader";
import { FaCheckCircle, FaTrashAlt, FaEdit, FaRocket, FaCube, FaPlus } from "react-icons/fa";
import { RiErrorWarningFill } from "react-icons/ri";
import regenerateToken from "../regenerateToken";
import { useHistory } from "react-router-dom";
import './versionManagement.css';
import axios from 'axios';
import { buildRequestConfig } from '../../utils/apiHelper';
import { isAdmin as checkAdmin } from '../../utils/authUtils';

const VersionManagement = ({ setEditVersion }) => {
  const alert = useAlert();
  const history = useHistory();

  const [versionName, setVersionName] = useState("");
  const [validationError, setValidationError] = useState("");
  const [loader, setLoader] = useState(false);
  const [versionData, setVersionData] = useState("");
  const [versionLoader, setVersionLoader] = useState(false);
  const [deleteLoader, setDeleteLoader] = useState(false);
  const [deleteSuccessMessage, setDeleteSuccessMessage] = useState("");
  const [deleteErrorMessage, setDeleteErrorMessage] = useState("");
  const [open, setOpen] = useState(false);
  const [profileContent, setProfileContent] = useState("");
  const [parameterContent, setParameterContent] = useState("");
  const [openMakeLiveModal, setOpenMakeLiveModal] = useState(false);
  const [makeLiveLoader, setMakeLiveLoader] = useState(false);
  const [makeLiveSuccess, setMakeLiveSuccess] = useState(false);
  const [makeLiveError, setMakeLiveError] = useState(false);
  const [liveButtonLoader, setLiveButtonLoader] = useState(false);
  const [selectedDeleteVersion, setSelectedDeleteVersion] = useState("");
  const [chosenLiveVersion, setChosenLiveVersion] = useState("");

  const validateName = (name) => {
    const regex = /^[^A-Z\s]+$/;
    if (name && !regex.test(name)) {
      setValidationError("Name cannot contain uppercase letters & spaces");
    } else {
      setValidationError("");
      setVersionName(name);
    }
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    setLoader(true);
    try {
      const response = await handleSubmit();
      if (response.status === 401) {
        await regenerateToken();
        const response = await handleSubmit();
        const data = await response.json();
        if (data.isSuccess) {
          alert.success("Successfully created version");
          setEditVersion(versionName);
          fetchAllVersionsFinal();
        } else {
          alert.error(data?.error);
        }
      } else {
        const data = await response.json();
        if (data.isSuccess) {
          alert.success("Successfully created version");
          setEditVersion(versionName);
          fetchAllVersionsFinal();
        } else {
          alert.error(data?.error);
        }
      }
    } catch (e) {
      console.log("error in creating version", e);
      alert.error("Something went wrong. Please try again!");
    } finally {
      setLoader(false);
      setVersionName("");
    }
  };

  const handleSubmit = async () => {
    const payload = { versionName: versionName };
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/version/content`;
    // ── ADMIN PATH: use admin token (axios) + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "POST", url: apiUrl, data: payload }));
    }
    // ── CLIENT PATH (unchanged — uses native fetch) ────────────────────
    const idToken = Cookies.get("idToken");
    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: idToken,
      },
      body: JSON.stringify(payload),
    };

    const response = await fetch(apiUrl, options);
    return response;
  };

  const fetchAllVersionsFinal = async () => {
    setVersionLoader(true);
    try {
      const response = await fetchAllVersions();
      if (response.status === 401) {
        await regenerateToken();
        const response = await fetchAllVersions();
        const data = await response.json();
        if (data.isSuccess) {
          setVersionData(data.data);
          localStorage.setItem("versionData", JSON.stringify(data.data));
        }
      } else {
        const data = await response.json();
        if (data.isSuccess) {
          setVersionData(data.data);
          localStorage.setItem("versionData", JSON.stringify(data.data));
        }
      }
    } catch (e) {
      console.log("Error fetching version records", e);
    } finally {
      setVersionLoader(false);
    }
  };

  const fetchAllVersions = async () => {
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/version/content?versionName=${"all"}`;
    // ── ADMIN PATH: use admin token (axios) + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "GET", url: apiUrl }));
    }
    // ── CLIENT PATH (unchanged — uses native fetch) ────────────────────
    const idToken = Cookies.get("idToken");
    const options = {
      method: "GET",
      headers: {
        authorization: idToken,
      },
    };

    const response = await fetch(apiUrl, options);
    return response;
  };

  const handleDeleteVersion = async (name) => {
    setDeleteLoader(true);
    setDeleteSuccessMessage("");
    setDeleteErrorMessage("");
    try {
      const response = await deleteVersion(name);
      if (response.status === 401) {
        await regenerateToken();
        const response = await deleteVersion(name);
        const data = await response.json();
        if (data.isSuccess) {
          setDeleteSuccessMessage(data.data);
          fetchAllVersionsFinal();
          setEditVersion("");
        } else {
          setDeleteErrorMessage(data.error);
        }
      } else {
        const data = await response.json();
        if (data.isSuccess) {
          setDeleteSuccessMessage(data.data);
          fetchAllVersionsFinal();
          setEditVersion("");
        } else {
          setDeleteErrorMessage(data.error);
        }
      }
    } catch (e) {
      console.log("Error fetching version records", e);
      setDeleteErrorMessage("Something went wrong. Please try again later.");
    } finally {
      setDeleteLoader(false);
    }
  };

  const deleteVersion = async (name) => {
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/version/content?versionName=${name}&fileType=${"all"}`;
    // ── ADMIN PATH: use admin token (axios) + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "DELETE", url: apiUrl }));
    }
    // ── CLIENT PATH (unchanged — uses native fetch) ────────────────────
    const idToken = Cookies.get("idToken");
    const options = {
      method: "DELETE",
      headers: {
        authorization: idToken,
      },
    };

    const response = await fetch(apiUrl, options);
    return response;
  };

  const deleteConfirmModal = () => {
    return (
      <Modal
        size="md"
        show={open}
        onHide={() => setOpen(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton style={{ border: "none" }}>
        </Modal.Header>
        <Modal.Body>
          {deleteLoader ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : deleteSuccessMessage ? (
            <div className="vm-modal-success">
              <FaCheckCircle color="green" size={40} />
              <p className="vm-modal-title">{deleteSuccessMessage}</p>
            </div>
          ) : deleteErrorMessage ? (
            <div className="vm-modal-success">
              <RiErrorWarningFill color="red" size={40} />
              <p className="vm-modal-title">{deleteErrorMessage}</p>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: '1rem' }}>
              <RiErrorWarningFill color="#f59e0b" size={40} style={{ marginBottom: '1rem' }} />
              <h4 style={{ marginBottom: '10px' }}>Delete Version?</h4>
              <p style={{ color: '#64748b' }}>
                Are you sure, you want to delete <strong>{selectedDeleteVersion}</strong>?<br />
                This action cannot be undone.
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ border: "none", justifyContent: 'center', paddingBottom: '2rem' }}>
          {deleteSuccessMessage || deleteErrorMessage ? (
            <Button onClick={() => setOpen(false)} variant="secondary">Close</Button>
          ) : (
            <>
              <Button variant="outline-secondary" onClick={() => setOpen(false)}>Cancel</Button>
              <Button
                variant="danger"
                onClick={() => handleDeleteVersion(selectedDeleteVersion)}
                disabled={deleteLoader}
              >
                Confirm Delete
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  const makeLiveConfimModal = () => {
    return (
      <Modal
        size="md"
        show={openMakeLiveModal}
        onHide={() => setOpenMakeLiveModal(false)}
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header closeButton style={{ border: "none" }}></Modal.Header>
        <Modal.Body>
          {makeLiveLoader ? (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          ) : makeLiveSuccess ? (
            <div className="vm-modal-success">
              <FaCheckCircle color="green" size={40} />
              <p className="vm-modal-title">Success!</p>
              <p>Version <strong>{chosenLiveVersion}</strong> is now Live.</p>
            </div>
          ) : makeLiveError ? (
            <div className="vm-modal-success">
              <RiErrorWarningFill color="red" size={40} />
              <p className="vm-modal-title">Something went wrong!</p>
              <p>Please try again later.</p>
            </div>
          ) : (
            <div style={{ textAlign: "center", padding: '1rem' }}>
              <FaRocket color="#3b82f6" size={40} style={{ marginBottom: '1rem' }} />
              <h4 style={{ marginBottom: '10px' }}>Go Live?</h4>
              <p style={{ color: '#64748b' }}>
                Are you sure you want to promote <strong>{chosenLiveVersion}</strong> to Live?
              </p>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer style={{ border: "none", justifyContent: 'center', paddingBottom: '2rem' }}>
          {makeLiveSuccess || makeLiveError ? (
            <Button onClick={() => setOpenMakeLiveModal(false)} variant="secondary">Close</Button>
          ) : (
            <>
              <Button variant="outline-secondary" onClick={() => setOpenMakeLiveModal(false)}>Cancel</Button>
              <Button
                variant="primary"
                onClick={() => handleLiveConfim()}
                disabled={makeLiveLoader}
              >
                Confirm Live
              </Button>
            </>
          )}
        </Modal.Footer>
      </Modal>
    );
  };

  // get profileContent of specific version
  const getProfileContent = async (selectedVersion) => {
    const idToken = Cookies.get("idToken");
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/content/profile?version=${selectedVersion}`;
    const options = {
      method: "GET",
      headers: {
        authorization: idToken,
      },
    };
    const response = await fetch(apiUrl, options);
    return response;
  };

  const getFinalProfileContent = async (selectedVersion) => {
    const response = await getProfileContent(selectedVersion);
    if (response.status === 401) {
      await regenerateToken();
      const response = await getProfileContent(selectedVersion);
      const data = await response.json();
      if (data.isSuccess) {
        setProfileContent(data.data);
      }
    } else {
      const data = await response.json();
      console.log("getModifiedData", data);
      if (data.isSuccess) {
        setProfileContent(data.data);
      }
    }
  };

  const handleProfileUpdate = async () => {
    try {
      const response = await updateProfileContent();
      // console.log(response);
      if (response.status === 401) {
        await regenerateToken();
        const response = await updateProfileContent();
        const data = await response.json();
        console.log("response generated after regeneration", data);
      } else {
        const data = await response.json();
        console.log("updateProfile", data);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const updateProfileContent = async () => {
    console.log("updatedContent", profileContent);
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/content/profile?version=${""}`;
    // ── ADMIN PATH: use admin token (axios) + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "POST", url: apiUrl, data: profileContent }));
    }
    // ── CLIENT PATH (unchanged — uses native fetch) ────────────────────
    const idToken = Cookies.get("idToken");
    const options = {
      method: "POST",
      headers: {
        authorization: idToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(profileContent),
    };
    const response = await fetch(apiUrl, options);
    return response;
  };

  const handleParameterUpdate = async () => {
    try {
      const response = await updateParameterContent();
      // console.log(response);
      if (response.status === 401) {
        await regenerateToken();
        const response = await updateParameterContent();
        const data = await response.json();
        console.log("response generated after regeneration", data);
      } else {
        const data = await response.json();
        console.log("updateProfile", data);
      }
    } catch (e) {
      console.log(e.message);
    }
  };

  const updateParameterContent = async () => {
    console.log("updatedContent", parameterContent);
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/content/parameter?version=${""}`;
    // ── ADMIN PATH: use admin token (axios) + inject clientId if a client is selected
    if (checkAdmin()) {
      return await axios(buildRequestConfig({ method: "POST", url: apiUrl, data: parameterContent }));
    }
    // ── CLIENT PATH (unchanged — uses native fetch) ────────────────────
    const idToken = Cookies.get("idToken");
    const options = {
      method: "POST",
      headers: {
        authorization: idToken,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(parameterContent),
    };
    const response = await fetch(apiUrl, options);
    return response;
  };

  const getParameterContent = async (selectedVersion) => {
    const idToken = Cookies.get("idToken");
    const apiUrl = `https://ap94204xve.execute-api.ap-south-1.amazonaws.com/prod/content/parameter?version=${selectedVersion}`;
    const options = {
      method: "GET",
      headers: {
        authorization: idToken,
      },
    };
    const response = await fetch(apiUrl, options);
    return response;
  };

  const getFinalParameterContent = async (selectedVersion) => {
    const response = await getParameterContent(selectedVersion);
    if (response.status === 401) {
      await regenerateToken();
      const response = await getParameterContent(selectedVersion);
      const data = await response.json();
      if (data.isSuccess) {
        setParameterContent(data.data);
      }
    } else {
      const data = await response.json();
      console.log("getModifiedData", data);
      if (data.isSuccess) {
        setParameterContent(data.data);
      }
    }
  };

  const handleLiveConfim = async () => {
    console.log("getContents", profileContent, parameterContent);
    setMakeLiveLoader(true);
    setMakeLiveSuccess(false);
    setMakeLiveError(false);
    try {
      await handleProfileUpdate();
      await handleParameterUpdate();
      setMakeLiveSuccess(true);
    } catch (e) {
      console.log("update error", e);
      setMakeLiveError(true);
    } finally {
      setMakeLiveLoader(false);
      setEditVersion("");
    }
  };

  const makeSpecificVersionLive = async (selectedVersion) => {
    setMakeLiveError(false);
    setLiveButtonLoader(true);
    await getFinalProfileContent(selectedVersion);
    await getFinalParameterContent(selectedVersion);

    setOpenMakeLiveModal(true);
  };

  // edit
  const handleEdit = (name) => {
    setEditVersion(name);
    history.replace("/profile-content");
  };

  useEffect(() => {
    fetchAllVersionsFinal();
  }, []);

  return (
    <AppLayout>
      <div className="vm-container">
        {/* Header */}
        <header className="vm-header">
          <div className="vm-title-group">
            <h1 className="vm-title">Version Management</h1>
            <p className="vm-subtitle">Create, manage, and deploy content versions.</p>
          </div>
        </header>

        <div className="vm-bento-grid">

          {/* Left Column: Version List */}
          <div className="vm-card">
            <div className="vm-card-header">
              <span className="d-flex align-items-center gap-2">
                <FaCube style={{ color: '#3b82f6' }} />
                <h3 className="vm-card-title">All Versions</h3>
              </span>
              <span style={{ fontSize: '0.85rem', color: '#64748b' }}>
                {versionData ? versionData.length : 0} versions found
              </span>
            </div>

            <div className="vm-card-body" style={{ padding: versionLoader ? '3rem' : '0' }}>
              {versionLoader ? (
                <div className="text-center">
                  <Spinner animation="border" variant="primary" />
                </div>
              ) : (
                <div className="vm-list-container">
                  {versionData && versionData.length > 0 && (
                    <div className="vm-list-header">
                      <div>#</div>
                      <div>Created At</div>
                      <div className="text-center">Version Name</div>
                      <div className="text-end">Actions</div>
                    </div>
                  )}

                  {versionData && versionData.length > 0 ? (
                    versionData.map((each, idx) => (
                      <div className="vm-list-row" key={idx}>
                        <div>{idx + 1}</div>
                        <div style={{ color: '#64748b', fontSize: '0.9rem' }}>
                          {new Date(each.createdAt).toLocaleDateString()}
                          <span style={{ fontSize: '0.75rem', marginLeft: '6px', color: '#94a3b8' }}>
                            {new Date(each.createdAt).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                          </span>
                        </div>
                        <div className="text-center">
                          <span className="vm-badge">{each.name}</span>
                        </div>
                        <div className="vm-actions-group">
                          <button
                            className="vm-action-btn vm-btn-edit"
                            onClick={() => handleEdit(each.name)}
                            title="Edit Version"
                          >
                            <FaEdit size={14} />
                          </button>
                          <button
                            className="vm-action-btn vm-btn-live"
                            onClick={() => {
                              setChosenLiveVersion(each.name);
                              makeSpecificVersionLive(each.name);
                            }}
                            title="Make Live"
                          >
                            <FaRocket size={14} />
                          </button>
                          <button
                            className="vm-action-btn vm-btn-delete"
                            onClick={() => {
                              setSelectedDeleteVersion(each.name);
                              setOpen(true);
                              setDeleteSuccessMessage("");
                              setDeleteErrorMessage("");
                            }}
                            title="Delete Version"
                          >
                            <FaTrashAlt size={14} />
                          </button>
                        </div>
                      </div>
                    ))
                  ) : (
                    <div className="text-center py-5 text-muted">
                      No versions found. Create one to get started.
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Right Column: Create New */}
          <div className="vm-card" style={{ height: 'fit-content' }}>
            <div className="vm-card-header">
              <span className="d-flex align-items-center gap-2">
                <FaPlus style={{ color: '#10b981' }} />
                <h3 className="vm-card-title">Create New</h3>
              </span>
            </div>
            <div className="vm-card-body">
              <Form onSubmit={handleCreate}>
                <div className="vm-form-group">
                  <label className="vm-label">Version Name</label>
                  <input
                    className="vm-input"
                    type="text"
                    placeholder="e.g. v2.0-beta"
                    value={versionName}
                    onChange={(e) => validateName(e.target.value)}
                    required
                  />
                  {validationError ? (
                    <div className="vm-error-msg">{validationError}</div>
                  ) : (
                    <div style={{ fontSize: '0.8rem', color: '#94a3b8', marginTop: '4px' }}>
                      No uppercase letters or spaces allowed.
                    </div>
                  )}
                </div>
                <button
                  type="submit"
                  className="vm-btn-create"
                  disabled={loader || validationError}
                >
                  {loader ? <Spinner animation="border" size="sm" /> : <>Create Version</>}
                </button>
              </Form>
            </div>
          </div>

        </div>

        {/* Modals */}
        {deleteConfirmModal()}
        {makeLiveConfimModal()}
      </div>
    </AppLayout>
  );
};

export default VersionManagement;
